/**
 * Internal Dependencies
 */
const metadata = {
  name: "welcome-screen",
  attributes: {
    buttonText: {
      type: "string",
      "default": "Let's start!"
    }
  },
  supports: {
    editable: false,
    required: false,
    attachment: true,
    description: true,
    logic: false
  }
};
const {
  name
} = metadata;
export { name, metadata };
//# sourceMappingURL=index.js.map